import naja from 'naja'

export default function(root) {
	let timeout = null

	Array.from(root.querySelectorAll('.typeahead[data-typeahead-url]'))
		.forEach(typeahead => {
			let query = ''
			let minLength = typeahead.getAttribute('data-min-length')
			let delay = typeahead.getAttribute('data-delay')
			let input = typeahead.querySelector('input.query')
			let target = typeahead.querySelector(typeahead.getAttribute('data-target'))
			let container = document.createElement('div')
			container.setAttribute('class', 'list-group shadow-sm')

			input.addEventListener('keydown', e => {
				if(e.keyCode === 13) { // Enter
					e.preventDefault()

					container.classList.add('d-none')
				}
			})

			input.addEventListener('keyup', e => {
				if(e.keyCode === 13) { // Enter
					e.preventDefault()

					container.classList.add('d-none')
					if(target) {
						const event = new Event('fill')
						target.dispatchEvent(event)
					}

				} else if(e.keyCode === 38) { // arrow UP
					e.preventDefault()

					container.classList.remove('d-none')
					let listItem = container.querySelector('a.active')
					let newItem = listItem ? listItem.previousElementSibling : container.querySelector('a:first-child')
					if(newItem) {
						newItem.classList.add('active')
						if(listItem) {
							listItem.classList.remove('active')
						}

						if (target) {
							target.value = newItem.getAttribute('data-id')
							const event = new Event('change')
							target.dispatchEvent(event)
						}
						input.value = newItem.textContent

						if (target) {
							const event = new Event('done')
							target.dispatchEvent(event)
						}
					}
				} else if(e.keyCode === 40) { // arrow DOWN
					e.preventDefault()

					container.classList.remove('d-none')
					let listItem = container.querySelector('a.active')
					let newItem = listItem ? listItem.nextElementSibling : container.querySelector('a:first-child')
					if(newItem) {
						newItem.classList.add('active')
						if(listItem) {
							listItem.classList.remove('active')
						}

						if (target) {
							target.value = newItem.getAttribute('data-id')
							const event = new Event('change')
							target.dispatchEvent(event)
						}
						input.value = newItem.textContent

						if (target) {
							const event = new Event('done')
							target.dispatchEvent(event)
						}
					}

				} else if(query !== input.value) {
					if(target) {
						target.value = ''
						const event = new Event('change')
						target.dispatchEvent(event)
					}

					query = input.value
					if(query.length >= (minLength ?? 2)) {
						if(timeout) {
							clearTimeout(timeout)
						}

						timeout = setTimeout(() => {
							let response = typeahead.querySelector('.response')
							let loading = typeahead.querySelector('.loading')

							loading.classList.remove('d-none')
							response.innerHTML = ''

							naja.makeRequest('get', typeahead.getAttribute('data-typeahead-url'), {query: input.value}, {history: false}).catch(error => {
								response.innerHTML = error

							}).then(payload => {
								container.innerHTML = ''
								if(payload.length > 0) {
									for (let item of payload) {
										let listItem = document.createElement('a')
										listItem.setAttribute('class', 'list-group-item list-group-item-action')
										listItem.setAttribute('href', '#')
										listItem.setAttribute('data-id', item.id)
										listItem.text = item.value

										listItem.addEventListener('click', e => {
											e.preventDefault()

											e.target.classList.add('active')
											if (target) {
												target.value = e.target.getAttribute('data-id')
												const event = new Event('fill')
												target.dispatchEvent(event)
											}
											input.value = e.target.textContent
											container.classList.add('d-none')

											input.focus()
											if (target) {
												const event = new Event('done')
												target.dispatchEvent(event)
											}
										})

										container.appendChild(listItem)
									}

									loading.classList.add('d-none')
									response.appendChild(container)

								} else {
									loading.classList.add('d-none')
									response.innerHTML = payload.error
								}

								container.classList.remove('d-none')
							})
						}, delay ?? 300)
					}
				}
			})
	})
}
